import { Component, OnInit, inject } from '@angular/core';

import { SelectOnlyComponent } from '../select-only/select.component';

@Component({
  selector: 'ux-select-only-items',
  templateUrl: './select-only-items.component.html',
  styleUrls: ['./select-only-items.component.less'],
  imports: [],
})
export class SelectOnlyItemsComponent implements OnInit {
  selectOnlyComponent = inject(SelectOnlyComponent);

  constructor() {}

  ngOnInit() {}
}
